import axios from 'axios';
import { toast } from 'react-hot-toast';

// Create a single, pre-configured axios instance
const apiClient = axios.create({
  // Use the environment variable injected by our CI/CD pipeline
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Important for sending cookies with auth tokens
  timeout: 15000, // 15 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add an interceptor to automatically attach the auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const userAuthToken = localStorage.getItem('token');
    if (userAuthToken) {
      config.headers['Authorization'] = `Bearer ${userAuthToken}`;
    }

    // Add request ID for debugging
    const requestId = Math.random().toString(36).substring(2, 9);
    config.headers['X-Request-ID'] = requestId;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add an interceptor to handle common API errors globally
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // const requestId = error.config?.headers?.['X-Request-ID'];

    if (error.response?.status === 401) {
      // Handle unauthorized errors, e.g., redirect to login
      toast.error('Your session has expired. Please log in again.');
      // Clear token and redirect to login
      localStorage.removeItem('token');
      // window.location.href = '/login';
    } else if (error.response?.status === 500) {
      toast.error('An unexpected server error occurred.');
    } else if (error.response?.status === 403) {
      toast.error('Access denied.');
    } else if (error.response?.status === 404) {
      toast.error('Resource not found.');
    } else if (!error.response) {
      // Network error
      toast.error('Network error. Please check your connection.');
    }

    return Promise.reject(error);
  }
);

// Debug helper to check API configuration

export default apiClient;
